module.exports = __webpack_public_path__ + "static/media/main idea.df484ff6.mp3";